import { $themeBreakpoints } from '@themeConfig'

export default {
  watch: {
    $route() {
      // Sinkron sama isDesktopMode di useVerticalLayout.js: mode overlay (auto
      // close on navigate) sekarang cuma di bawah 'md' (768px), bukan 'xl' lagi.
      if (this.$store.state.app.windowWidth < $themeBreakpoints.md) {
        this.isVerticalMenuActive = false
      }
    },
  },
}
